import { comics } from '../mocks/comics';
import { news } from '../mocks/news';
import type { Comic, NewsItem } from '../types/content';

export function findComic(id: string): Comic | undefined {
  return comics.find((item) => item.id === id);
}

export function findNews(id: string): NewsItem | undefined {
  return news.find((item) => item.id === id);
}

export function findContent(type: string, id: string): Comic | NewsItem | undefined {
  return type === 'news' ? findNews(id) : findComic(id);
}

export interface FavoriteEntry {
  id: string;
  type: 'comics' | 'news';
  title: string;
  cover: string;
  summary: string;
}

export function getFavoriteEntries(ids: string[]): FavoriteEntry[] {
  const entries: FavoriteEntry[] = [];
  ids.forEach((id) => {
    const comic = comics.find((item) => item.id === id);
    if (comic) {
      entries.push({ id: comic.id, type: 'comics', title: comic.title, cover: comic.cover, summary: comic.summary });
      return;
    }
    const article = news.find((item) => item.id === id);
    if (article) {
      entries.push({ id: article.id, type: 'news', title: article.title, cover: article.cover, summary: article.summary });
    }
  });
  return entries;
}

export function getRelatedComics(current: Comic, count = 4): Comic[] {
  const sameGenre = comics.filter((item) => item.id !== current.id && item.genre === current.genre);
  const sameTag = comics.filter(
    (item) => item.id !== current.id && item.genre !== current.genre && item.tags.some((tag) => current.tags.includes(tag)),
  );
  const others = comics.filter((item) => item.id !== current.id);
  const merged = [...sameGenre, ...sameTag, ...others];
  const unique: Comic[] = [];
  merged.forEach((item) => {
    if (!unique.some((exist) => exist.id === item.id)) unique.push(item);
  });
  return unique.slice(0, count);
}

export function getRelatedNews(current: NewsItem, count = 3): NewsItem[] {
  const sameCategory = news.filter((item) => item.id !== current.id && item.category === current.category);
  const sameTag = news.filter(
    (item) => item.id !== current.id && item.category !== current.category && item.tags.some((tag) => current.tags.includes(tag)),
  );
  const others = news.filter((item) => item.id !== current.id);
  const merged = [...sameCategory, ...sameTag, ...others];
  const unique: NewsItem[] = [];
  merged.forEach((item) => {
    if (!unique.some((exist) => exist.id === item.id)) unique.push(item);
  });
  return unique.slice(0, count);
}